import React from "react";
import { Avatar } from "../../../../../../core/atoms/atoms";
import { CardContainer } from "../../../../../../shared/components/inspiration/cardContainer";
import { CollectionKeyHelper } from "../../../../../../shared/helpers/contentCollectionHelpers";
import { GoogleAnalyticsHelper } from "@travellocal/ui";

import "./contentGrid.scss";

interface Props {
  country: ICountry;
  contentState: IKeyedState<IPagerState<IContent>>;
  enquiryStatus: EnquiryStatus;
}

interface IContentGrid {
  title: string;
  key: string;
  type: ContentType;
  onClick: () => void;
}

const gaLabelForEnquiryStatus = (enquiryStatus: EnquiryStatus): string => {
  switch (enquiryStatus) {
    case EnquiryStatus.LowIntent:
      return "Low intent";
    case EnquiryStatus.Triage:
      return "Triage";
    default:
      return "Connected";
  }
};

export const ContentGrid: React.FC<Props> = ({ country, contentState, enquiryStatus }) => {
  // fallback to defaultLto image
  const avatar: ILocationImage | ILtoImage = country?.images
    && (
      country.images.find((image) => image.locationImageType === LocationImageType.LtoMain)
      || country.defaultLto.image
    );

  const gaLabel = gaLabelForEnquiryStatus(enquiryStatus);

  const content: IContentGrid[] = [
    {
      title: "Discover some of our favourite trip ideas",
      key: CollectionKeyHelper.LocationItineraries(country?.id),
      type: ContentType.SampleItinerary,
      onClick: () => GoogleAnalyticsHelper.logEvent("Select itinerary", "Click", gaLabel),
    },
    {
      title: "What previous travellers have said…",
      key: CollectionKeyHelper.LocationReviews(country?.id),
      type: ContentType.Review,
      onClick: () => GoogleAnalyticsHelper.logEvent("Select review", "Click", gaLabel),
    },
    {
      title: `Read some articles about ${country?.name}`,
      key: CollectionKeyHelper.LocationRelated(country?.id),
      type: ContentType.BlogPost,
      onClick: () => GoogleAnalyticsHelper.logEvent("Select article", "Click", gaLabel),
    },
  ];

  return (
    <div>
      {content.length > 0 && content.map((grid, i) => {
        // if there is no available content for this key don't render
        const collectionState = contentState?.data[grid.key];
        if (collectionState?.data && collectionState.data.length < 1) {
          return null;
        }

        return (
          <div key={`content-grid-${i}`}>
            <div className="customer-enq-content__intro">
              <Avatar
                source={avatar?.thumbnailUrl || "/images/missing-image.jpg"}
                className="customer-enq-content__avatar"
              />
              <h3 className="customer-enq-content__title">{grid.title}</h3>
            </div>
            <div className="customer-enq-content__grid">
              <CardContainer
                className="is-marginless"
                collectionKey={grid.key}
                cardLimit={6}
                filters={{ types: [grid.type], locations: [country.id] }}
                columnClassName="column is-6-tablet is-4-widescreen"
                isMultineColumn
                onClick={grid.onClick}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
